import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import MegaTable from ".";

const tbgroup = ({ stData = {} as any, stChange = (data = {}, type = '') => { } }) => {
  const [rowActive, setRowActive] = useState<number>(-1);
  const constAllmaxChild = (data: any) => {
    let count = 0;
    if (data.children) {
      data.children.forEach((child: any) => {
        if(!child.children) {
          count += 1;
        }
        count += constAllmaxChild(child);
      });
    }
    return count;
  }
  const columnDefs = useMemo(() => {
    const temp = [...stData.col || []];
    temp[0] = {
      ...temp[0],
      cellRenderer: (params: any) => {
        if (params.data.children) {
          return (<div className={`ctr-group-box ${params.data.isShown ? 'active' : ''}`} style={{ paddingLeft: `${(params.data.level - 1) * 15}px` }}>
            <div className="ctr-click" onClick={() => showChild(params.data.idx)}>
              <span className="icon">
                <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M0.667042 9.8232L5.68715 5.49389C5.83085 5.36997 5.83085 5.13135 5.68715 5.00611L0.667042 0.676798C0.479843 0.515964 0.205636 0.660978 0.205636 0.920684V9.57932C0.205636 9.83902 0.479843 9.98404 0.667042 9.8232Z" fill="currentColor" />
                </svg>
              </span>
              <span className="text">({constAllmaxChild(params.data)}) {params.data.level_key_value}</span>
            </div>
          </div>)
        } else {
          if (Object.prototype.hasOwnProperty.call(params.data, 'has_brand_permission') && params.data.has_brand_permission !== true) {
            return null;
          }
          return (<div className="view-detail-ctr" style={{ paddingLeft: `${(params.data.level - 1) * 15}px` }} onClick={() => {
            stChange(params.data, 'viewDetail')
            setRowActive(params?.node?.rowIndex);
          }}>
            <span className="icon">
              <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7 2.15625C10.0014 2.15625 12.2404 3.72662 13.7217 6.84668C13.842 7.10444 13.8419 7.39828 13.7217 7.65137C12.2404 10.7732 10.0031 12.3438 7 12.3438C3.99851 12.3437 1.75956 10.7735 0.27832 7.65332C0.218914 7.52753 0.187508 7.39009 0.1875 7.25098C0.1875 7.11185 0.218907 6.97444 0.27832 6.84863C1.75956 3.72679 3.99692 2.15628 7 2.15625ZM7 3.28125C4.47978 3.28128 2.63455 4.55951 1.33301 7.25C2.63456 9.94059 4.47973 11.2187 7 11.2188C9.52188 11.2188 11.367 9.94063 12.667 7.25C11.3654 4.55953 9.52024 3.28125 7 3.28125ZM6.9375 4.5C8.4562 4.5 9.68742 5.73132 9.6875 7.25C9.6875 8.76875 8.45625 10 6.9375 10C5.41879 9.99995 4.1875 8.76872 4.1875 7.25C4.18758 5.73135 5.41884 4.50005 6.9375 4.5ZM6.9375 5.5C5.9704 5.50005 5.18758 6.28291 5.1875 7.25C5.1875 8.21716 5.97035 8.99995 6.9375 9C7.90469 9 8.6875 8.21719 8.6875 7.25C8.68742 6.28288 7.90464 5.5 6.9375 5.5Z" fill="currentColor" />
              </svg>
            </span>
          </div>)
        }
      },
    }
    // temp[1] = {
    //   ...temp[1],
    //   cellRenderer: (params: any) => {
    //     if (params.data.children) {
    //       return (<div className="hight-text">Số lượng: {params.data.children.length}</div>)
    //     } else {
    //       return (<div>{params.data.own_vehicle_name}</div>)
    //     }
    //   },
    // }
    return temp;
  }, [stData.col]);


  const [treeData, setTreeData] = useState<any[]>([]);
  useEffect(() => {
    const newarray = groupToArrayWithLevelKeyEnd(stData.listData || [], stData.treeField || []);
    setTreeData(newarray);
  }, [stData.listData]);

  const [treeDataShow, setTreeDataShow] = useState<any[]>([]);
  useEffect(() => {
    setTreeDataShow(treeData);
  }, [treeData]);

  type GroupedItem = {
    level: string | number;
    level_key_name: string | null;
    level_key_value: any;
    children?: GroupedItem[];
    [key: string]: any;
  };

  const groupToArrayWithLevelKeyEnd = (
    data: any[],
    keys: string[],
    level = 1,
    parentIdx: string = ""
  ): GroupedItem[] => {
    if (!keys.length) {
      return data.map((item: any, i: number) => ({
        ...item,
        idx: `${parentIdx}${i}`,
        level: level,
        level_key_name: keys.length ? keys[keys.length - 1] : null,
        level_key_value: keys.length ? item[keys[keys.length - 1]] : null
      }));
    }
    const [first, ...rest] = keys;
    const groups = {} as Record<string, any[]>;
    data.forEach((item: any) => {
      const key = item[first];
      if (!groups[key]) groups[key] = [];
      groups[key].push(item);
    });
    let idxCounter = 0;
    return Object.entries(groups).map(([key, items]) => {
      const idx = `${parentIdx}${idxCounter++}`;
      const defaultItem = {} as any
      stData.col.forEach((col: any) => {
        defaultItem[col.field] = ' '
      })
      return {
        idx,
        level,
        isShown: false,
        level_key_name: first,
        level_key_value: key,
        children: groupToArrayWithLevelKeyEnd(items, rest, level + 1, `${idx}_`),
        ...defaultItem,
      };
    });
  };
  const showChild = (dataIdx = '') => {
    setTreeDataShow(prevData => {
      const index = prevData.findIndex(item => item.idx === dataIdx);
      if (index === -1) return prevData;
      const data = prevData[index];
      const newData = { ...data, isShown: !data.isShown };
      let newTreeDataShow = [...prevData];
      newTreeDataShow[index] = newData;

      if (newData.isShown && newData.children) {
        newTreeDataShow.splice(index + 1, 0, ...newData.children);
      } else if (!newData.isShown && newData.children) {
        const idxRemove = listIdxRemove(newData);
        newTreeDataShow = newTreeDataShow.filter(item => !idxRemove.includes(item.idx));
      }
      return newTreeDataShow;
    });
  }

  const listIdxRemove = (data: any): string[] => {
    let listIdx: string[] = [];
    if (data.children) {
      data.children.forEach((child: any) => {
        listIdx.push(child.idx);
        listIdx = listIdx.concat(listIdxRemove(child));
      });
    }
    return listIdx;
  }
  return (
    <MegaTable
      stData={{ ...stData, col: columnDefs, listData: treeDataShow || [], defaultColDef: { sortable: false }, rowActive }}
      stChange={(data: any, type: any) => {
        stChange(data.showSetting, 'showSetting');
      }}
    />
  );
};
export default tbgroup;
